var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverdue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25336",
    "data-name": "Group 25336",
    transform: "translate(0 0.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24849",
    "data-name": "Group 24849"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(0 -0.292)",
    fill: "#c00"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37102",
    "data-name": "Path 37102",
    d: "M313.159,258.96a.959.959,0,0,0-.829.478l-6.946,12.031a.957.957,0,0,0,.829,1.436h9.159a3.9,3.9,0,0,1,3.9-3.817c.1,0,.2.008.3.016l-5.582-9.666A.959.959,0,0,0,313.159,258.96Zm.7,11.46a.98.98,0,1,1,.289-.7A.984.984,0,0,1,313.857,270.42Zm.249-7.033-.605,4.1a.349.349,0,0,1-.339.373c-.217,0-.324-.111-.337-.349l-.607-4.126a.8.8,0,0,1,.184-.62,1.151,1.151,0,0,1,1.52,0A.815.815,0,0,1,314.106,263.387Z",
    transform: "translate(-298.151 -251.845)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25161",
    "data-name": "Group 25161",
    transform: "translate(6.196 6.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25160",
    "data-name": "Group 25160",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37103",
    "data-name": "Path 37103",
    d: "M314.833,272.367h-9.159a.957.957,0,0,1-.829-1.436l6.946-12.031a.957.957,0,0,1,1.658,0l5.582,9.666a3.873,3.873,0,0,1,1.219.294l-6.013-10.414a1.868,1.868,0,0,0-3.235,0l-6.946,12.031a1.867,1.867,0,0,0,1.618,2.8h9.245a3.917,3.917,0,0,1-.09-.828C314.829,272.421,314.833,272.394,314.833,272.367Z",
    transform: "translate(-303.808 -257.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37104",
    "data-name": "Path 37104",
    d: "M317.262,274.538a.982.982,0,1,0,.984.981.985.985,0,0,0-.984-.981Z",
    transform: "translate(-308.448 -263.846)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37105",
    "data-name": "Path 37105",
    d: "M317.282,264.566a.957.957,0,0,0-.76.286.8.8,0,0,0-.184.62l.607,4.126c.013.239.119.349.337.349a.35.35,0,0,0,.339-.373l.605-4.1a.815.815,0,0,0-.185-.62A.957.957,0,0,0,317.282,264.566Z",
    transform: "translate(-308.467 -260.136)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37106",
    "data-name": "Path 37106",
    d: "M327.989,280.955a.76.76,0,0,0-.63-.857c-.147-.04-.281-.08-.4-.107-.308-.08-.375-.107-.441-.2a.225.225,0,0,1-.04-.161.277.277,0,0,1,.134-.188.632.632,0,0,1,.415-.026.679.679,0,0,1,.456.335l.468-.268a1.326,1.326,0,0,0-.763-.576v-.389h-.536v.335a1,1,0,0,0-.322.107.833.833,0,0,0-.388.536.687.687,0,0,0,.134.576,1.12,1.12,0,0,0,.75.4,2.438,2.438,0,0,0,.375.121c.254.08.268.134.254.281,0,.094-.188.228-.389.268a.737.737,0,0,1-.71-.375l-.455.295a1.326,1.326,0,0,0,.764.576v.375h.536v-.348A.93.93,0,0,0,327.989,280.955Z",
    transform: "translate(-312.027 -265.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37107",
    "data-name": "Path 37107",
    d: "M326.781,275.4a3.872,3.872,0,0,0-1.22-.294c-.1-.008-.2-.016-.3-.016a3.9,3.9,0,0,0-3.9,3.817c0,.028,0,.055,0,.082a3.9,3.9,0,1,0,5.422-3.59Zm-4.637,3.59a3.115,3.115,0,1,1,3.115,3.115A3.118,3.118,0,0,1,322.144,278.99Z",
    transform: "translate(-310.338 -264.051)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdue);
export default __webpack_public_path__ + "static/media/overdue.e46ca2c1542cbfa8738a6fce883b3cb1.svg";
export { ForwardRef as ReactComponent };